import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=65742cdc&scoped=true&lang=html&"
import script from "./offers.vue?vue&type=script&lang=js&"
export * from "./offers.vue?vue&type=script&lang=js&"
import style0 from "./offers.vue?vue&type=style&index=0&id=65742cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65742cdc",
  null
  
)

export default component.exports